<template>
    <div>
        <v-row>
            <v-col cols="12">
                <SportipsButton @onClick="campaignStore.current_step = 1" chevronLeft fullWidth class="mb-4">Etape
                    précedente
                </SportipsButton>
                <div class="field_label">Objet de l'email <span class="text-red">*</span></div>
                <v-text-field v-model="campaignStore.subject" required :rules="[$formRules.required]"></v-text-field>
                <div class="field_label">En-tête de l'email <span class="text-red">*</span></div>
                <v-text-field v-model="campaignStore.pre_header" required :rules="[$formRules.required]"></v-text-field>
                <ContentBuilder></ContentBuilder>


            </v-col>
        </v-row>

    </div>
</template>

<script>
import { useCampaignStore } from "@/stores/mailingSystem/campaignStore";
import { mapStores } from "pinia";
import ContentBuilder from "./EmailContent/ContentBuilder.vue";
export default {
    components: { ContentBuilder },
    computed: {
        ...mapStores(useCampaignStore),
    },

}
</script>

<style lang="scss" scoped></style>